import { Notification } from "@/components/admin/notification";
import { useTranslate } from "ra-core";
import { brandLogo, brandMark } from "../root/logos/brand";

export const ConfirmationRequired = () => {
  const translate = useTranslate();
  const title = "Georgia Web Co CRM";
  const logo = brandLogo;
  const mark = brandMark;

  return (
    <div className="min-h-screen flex bg-white text-[#0f1626]">
      <div className="relative grid w-full lg:grid-cols-2">
        <div className="relative hidden min-h-screen flex-col p-10 text-white lg:flex">
          <div
            className="absolute inset-0"
            style={{
              background:
                "radial-gradient(ellipse 80% 60% at 20% 10%, rgba(253,118,26,0.35), transparent 55%), #0f1626",
            }}
          />
          <div className="relative z-20 flex items-center gap-3">
            <img className="h-10 w-auto" src={mark} alt={title} />
            <span className="text-white text-lg font-semibold">
              Georgia Web Co <span className="text-[#fd761a]">CRM</span>
            </span>
          </div>
          <div className="relative z-20 mt-auto max-w-md">
            <p className="text-3xl font-semibold leading-tight text-white">
              Almost there
            </p>
            <p className="mt-4 text-base text-white/80">
              Confirm your email to finish setting up Georgia Web Co CRM.
            </p>
          </div>
        </div>
        <div className="flex flex-col justify-center w-full px-6 py-10 sm:px-10 lg:p-12 bg-white text-[#0f1626]">
          <div className="w-full max-w-[420px] mx-auto space-y-4 rounded-xl border-2 border-[#c5ceda] bg-white p-8 shadow-[0_12px_32px_rgba(15,22,38,0.1)]">
            <img
              className="h-10 w-auto max-w-[220px] object-contain mb-2 lg:hidden"
              src={logo}
              alt={title}
            />
            <h1 className="text-2xl font-bold tracking-tight text-[#0f1626]">
              Check your inbox
            </h1>
            <p className="text-base text-[#3d4654] leading-relaxed">
              {translate("crm.auth.confirmation_required", {
                _: "Please follow the link we just sent you by email to confirm your account.",
              })}
            </p>
          </div>
        </div>
      </div>
      <Notification />
    </div>
  );
};

ConfirmationRequired.path = "/sign-up/confirm";
